var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38755 33.0012H0.545698V10.9682H7.38755V33.0012ZM3.9625 7.96271C1.77499 7.96271 0 6.15001 0 3.9625C0 2.91158 0.417477 1.9037 1.16059 1.16059C1.9037 0.417476 2.91158 0 3.9625 0C5.01342 0 6.0213 0.417476 6.76441 1.16059C7.50752 1.9037 7.925 2.91158 7.925 3.9625C7.925 6.15001 6.15001 7.96271 3.9625 7.96271ZM32.9941 33.0012H26.1676V22.2758C26.1676 19.7194 26.1157 16.4417 22.6105 16.4417C19.0535 16.4417 18.5078 19.2185 18.5078 22.0919V33.0012H11.673V10.9682H18.2343V13.9736H18.3298C19.2432 12.2423 21.4743 10.4154 24.8027 10.4154C31.7271 10.4154 33 14.9755 33 20.898V33.0012H32.9941Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector-3.2f8d138fb979e67dd7871140d24d89d5.svg";
export { ForwardRef as ReactComponent };